import { setupFocusTrap, handleTab, debounce } from './helpers';

export default function headerMenu () {
	const RESIZE_TIMEOUT = 200;
	const MOBILE_WIDTH = 1024;

	const headerMenu = document.querySelector(".js-header-menu");
	const headerMenuButtons = document.querySelectorAll('.js-header-menu-button');
	const headerMenuCloseButtons = document.querySelectorAll('.js-header-menu-close-button');

	const handleResize = debounce(() => {
		if (window.innerWidth > MOBILE_WIDTH) {
			closeHeaderMenu();
		}
	}, RESIZE_TIMEOUT);

	const handleSetupFocusTrap = (btn) => {
		setupFocusTrap(headerMenu, btn);
	}

	const handleHeaderMenuTab = (event) => {
		handleTab(event, headerMenu);
	}

	const openHeaderMenu = (btn) => {
		headerMenu.style.display = "flex";
		btn.setAttribute('aria-expanded', 'true');
		document.body.classList.add("header-menu__no-scroll");
		handleSetupFocusTrap(btn);
		headerMenu.addEventListener('keydown', handleHeaderMenuTab);
		window.addEventListener('resize', handleResize);
	}

	const closeHeaderMenu = () => {
		headerMenu.style.display = "none";
		headerMenuButtons.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
		document.body.classList.remove("header-menu__no-scroll");
		headerMenu.removeEventListener('keydown', handleHeaderMenuTab);
		window.removeEventListener('resize', handleResize);
	}

	if (headerMenuButtons) {
		headerMenuButtons.forEach((btn) => {
			btn.addEventListener('click', () => openHeaderMenu(btn));
		})
	}

	// Mobile menu: tapping a submenu group title expands / collapses its items.
	document.querySelectorAll('.js-header-menu .header-submenu__parent').forEach((btn) => {
		btn.setAttribute('aria-expanded', 'false');
		btn.addEventListener('click', () => {
			const isOpen = btn.closest('.js-header-submenu').classList.toggle('header-submenu--open');
			btn.setAttribute('aria-expanded', String(isOpen));
		});
	});

	if (headerMenuCloseButtons) {
		headerMenuCloseButtons.forEach((btn) => {
			btn.addEventListener("click", closeHeaderMenu);
		})
	}
}
